/**
 * @fileoverview Hook Actions Layer para gestión de eventos de cliente en el modal de actividad.
 * Separa la lógica de negocio (guardar evento, loading, error) de la UI.
 * @module useCustomerEventActions
 * @category Hook - Actions Layer
 * @since 1.0.0
 * @version 1.0.0
 */

import { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import CustomersModelMc from '../../../models/CustomersModelMc';
import { LOAD_DATA_FAILURE } from '../../../../actions/inbox/conversationActions';
import { sharingInformationService } from '../../../../services/sharingInformationService';

export default function useCustomerEventActions({ formMethods, subcategoryOptions, closeModal, chatId }) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  /**
   * Transforma los datos del formulario al formato esperado por la API.
   * @param {Object} formData - Datos del formulario
   * @returns {Object} Objeto transformado
   */
  const transformFormData = useCallback((formData) => {
    const subcategoryObj = subcategoryOptions.find(option => option.id === formData.subcategory);
    const payload = {
      customer_event: {
        action: formData.action,
        type_event: subcategoryObj?.id || '',
        subcategory: subcategoryObj?.label || ''
      }
    };
    if (chatId) {
      payload.customer_event.chat_id = chatId;
    }
    return payload;
  }, [subcategoryOptions, chatId]);

  const handleSaveButtonClick = useCallback(() => {
    formMethods.handleSubmit(async (formData) => {
      setLoading(true);
      const params = transformFormData(formData);
      try {
        await CustomersModelMc.saveCustomerEvent(formData.web_id, params);
        sharingInformationService.setSubject({
          reloadCustomerEvents: true
        });
        sharingInformationService.setSubject({});
        closeModal();
      } catch (error) {
        dispatch({
          type: LOAD_DATA_FAILURE,
          error: error?.message || 'Error updating conversation state'
        });
      } finally {
        setLoading(false);
      }
    })();
  }, [formMethods, transformFormData, dispatch, closeModal]);

  return {
    loading,
    handleSaveButtonClick
  };
}
